import { Button } from '../components/Button';
import { Eyebrow, Footer, TopBar } from '../components/Site';
import { usePageMeta } from '../lib/meta';

/** Any path the router doesn't know. The server answers these with a 404
 *  status too (spaRoute in backend/internal/http/server.go). */
export function NotFound() {
  usePageMeta('Page not found — shotmeal', 'This page doesn’t exist.');
  return (
    <main class="page-in">
      <TopBar />
      <section style={{ padding: '96px 0 120px' }}>
        <div class="container" style={{ textAlign: 'center', maxWidth: 640 }}>
          <Eyebrow>404</Eyebrow>
          <h1 class="wordmark section-title" style={{ fontSize: 'clamp(40px, 7vw, 72px)' }}>
            Nothing on this <span class="accent">plate.</span>
          </h1>
          <p style={{ color: 'var(--ink-2)', fontSize: 17, lineHeight: 1.55, margin: '18px auto 28px' }}>
            The page you're looking for doesn't exist or has moved.
          </p>
          <Button href="/" size="md">Back to shotmeal</Button>
        </div>
      </section>
      <Footer />
    </main>
  );
}
